<div *ngIf="field" class="form-group" [formGroup]="baseFormGroup" [required]="!field.fieldIsDisabled"
  [appDisable]="field.fieldIsDisabled">
  <app-aaos-form-field-title [field]="field" [displayText]="display"></app-aaos-form-field-title>
  <input style="width: 100%" type="text" class="form-control" formControlName="{{field.name}}" matInput
    (input)="componentChange($event)" rows="5" cols="40" />

  <div class="required-text" *ngIf="invalidField(field.name)">Valid {{field.displayName}} is required
  </div>

</div>